import { useCallback, useEffect, useRef, useState } from 'react';

// The selection and its form must have the same owner before any edit, cache
// write or save is allowed. Selection effects run after rendering; returning an
// empty, unready form here closes that interval without depending on effect order.
export default function useScopedInterventionForm(scope, emptyForm) {
  const [state, setState] = useState({ scope: null, form: emptyForm });
  const mounted = useRef(true);
  useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; };
  }, []);
  const currentScope = useRef(scope);
  currentScope.current = scope;
  const ready = state.scope === scope;
  const setForm = useCallback(update => {
    setState(previous => {
      if (currentScope.current !== scope || previous.scope !== scope) return previous;
      return { scope, form: typeof update === 'function' ? update(previous.form) : update };
    });
  }, [scope]);
  const hydrateForm = useCallback(form => {
    if (currentScope.current !== scope) return;
    setState({ scope, form });
  }, [scope]);
  const isCurrentScope = useCallback(() => mounted.current && currentScope.current === scope, [scope]);
  return { form: ready ? state.form : emptyForm, setForm, hydrateForm, ready, isCurrentScope };
}
